// @flow

const navigation = (state: any = {}, action: any) => {
  switch(action.type) {
    case 'SET_TITLE':
      return { title: action.title };
    case 'CLEAR_TITLE':
      return {};
    default:
      return state;
  }
}

export default navigation;



// WEBPACK FOOTER //
// ./src/reducers/navigation.js